export default __webpack_public_path__ + "static/media/2_icon6B.5c754822.png";